// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

/* Ant Layout Overrides */
:where(.css-dev-only-do-not-override-uyvgyi).ant-layout,
:where(.css-dev-only-do-not-override-uyvgyi).ant-layout .ant-layout-header,
:where(.css-dev-only-do-not-override-uyvgyi).ant-layout .ant-layout-sider,
:where(.css-dev-only-do-not-override-uyvgyi).ant-layout .ant-layout-footer,
:where(.css-uyvgyi).ant-layout,
:where(.css-uyvgyi).ant-layout .ant-layout-header,
:where(.css-uyvgyi).ant-layout .ant-layout-sider,
:where(.css-uyvgyi).ant-layout .ant-layout-footer {
  background: #eeeeee !important;
}

/* Button Styles */
.ant-btn-primary {
  background-color: #3E00D5 !important;
  border-color: #3E00D5 !important;
}

/* Select Styles */
.ant-select-focused .ant-select-selector,
.ant-select:hover .ant-select-selector {
  border-color: #DDFF56 !important;
}

/* Input and Form Item Styles */
.ant-form-item-control-input:focus .ant-input,
.ant-form-item-control-input:hover .ant-input,
.datepicker-hover:hover,
.ant-btn:hover,
.ant-btn:focus {
  border-color: #DDFF56 !important;
}

/* DatePicker Styles */
.ant-picker-focused .ant-picker-input > input:focus,
.ant-picker-focused .ant-picker-input > input:hover,
.ant-picker:hover .ant-picker-input > input:focus,
.ant-picker:hover .ant-picker-input > input:hover {
  border-color: #DDFF56 !important;
  border-right-width: 1px !important;
}

/* DatePicker Styles */
.ant-picker-focused .ant-picker-input > input {
  border-color: #DDFF56;
  border-right-width: 1px;
}

/* Add this to include hover state */
.ant-picker:hover .ant-picker-input > input {
  border-color: #DDFF56;
  border-right-width: 1px;
}

/* More Layout and Element Overrides */
:where(.css-dev-only-do-not-override-12k1gsx).ant-layout,
:where(.css-dev-only-do-not-override-12k1gsx).ant-layout .ant-layout-header,
:where(.css-dev-only-do-not-override-12k1gsx).ant-layout .ant-layout-sider,
:where(.css-dev-only-do-not-override-12k1gsx).ant-layout .ant-layout-footer,
:where(.css-12k1gsx).ant-layout,
:where(.css-12k1gsx).ant-layout .ant-layout-header,
:where(.css-12k1gsx).ant-layout .ant-layout-sider,
:where(.css-12k1gsx).ant-layout .ant-layout-footer {
  background: #444444 !important;
}

/* Further Specific Overrides */
:where(.css-12k1gsx).ant-layout .ant-select-selector {
  background: #272822 !important;
}

:where(.css-12k1gsx).ant-card,
:where(.css-12k1gsx).ant-input-group {
  background: #5b5b5b !important;
}

.account-label-width .ant-form-item-label {
  text-align: left;
  width: 100px;
}

.ant-layout-sider-children {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,8JAA8J;EAC9J,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+EAA+E;AACjF;;AAEA,yBAAyB;AACzB;;;;;;;;EAQE,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;;EAEE,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;;;;;EAKE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;;;;EAIE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;;;;;;;;EAQE,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n/* Ant Layout Overrides */\n:where(.css-dev-only-do-not-override-uyvgyi).ant-layout,\n:where(.css-dev-only-do-not-override-uyvgyi).ant-layout .ant-layout-header,\n:where(.css-dev-only-do-not-override-uyvgyi).ant-layout .ant-layout-sider,\n:where(.css-dev-only-do-not-override-uyvgyi).ant-layout .ant-layout-footer,\n:where(.css-uyvgyi).ant-layout,\n:where(.css-uyvgyi).ant-layout .ant-layout-header,\n:where(.css-uyvgyi).ant-layout .ant-layout-sider,\n:where(.css-uyvgyi).ant-layout .ant-layout-footer {\n  background: #eeeeee !important;\n}\n\n/* Button Styles */\n.ant-btn-primary {\n  background-color: #3E00D5 !important;\n  border-color: #3E00D5 !important;\n}\n\n/* Select Styles */\n.ant-select-focused .ant-select-selector,\n.ant-select:hover .ant-select-selector {\n  border-color: #DDFF56 !important;\n}\n\n/* Input and Form Item Styles */\n.ant-form-item-control-input:focus .ant-input,\n.ant-form-item-control-input:hover .ant-input,\n.datepicker-hover:hover,\n.ant-btn:hover,\n.ant-btn:focus {\n  border-color: #DDFF56 !important;\n}\n\n/* DatePicker Styles */\n.ant-picker-focused .ant-picker-input > input:focus,\n.ant-picker-focused .ant-picker-input > input:hover,\n.ant-picker:hover .ant-picker-input > input:focus,\n.ant-picker:hover .ant-picker-input > input:hover {\n  border-color: #DDFF56 !important;\n  border-right-width: 1px !important;\n}\n\n/* DatePicker Styles */\n.ant-picker-focused .ant-picker-input > input {\n  border-color: #DDFF56;\n  border-right-width: 1px;\n}\n\n/* Add this to include hover state */\n.ant-picker:hover .ant-picker-input > input {\n  border-color: #DDFF56;\n  border-right-width: 1px;\n}\n\n/* More Layout and Element Overrides */\n:where(.css-dev-only-do-not-override-12k1gsx).ant-layout,\n:where(.css-dev-only-do-not-override-12k1gsx).ant-layout .ant-layout-header,\n:where(.css-dev-only-do-not-override-12k1gsx).ant-layout .ant-layout-sider,\n:where(.css-dev-only-do-not-override-12k1gsx).ant-layout .ant-layout-footer,\n:where(.css-12k1gsx).ant-layout,\n:where(.css-12k1gsx).ant-layout .ant-layout-header,\n:where(.css-12k1gsx).ant-layout .ant-layout-sider,\n:where(.css-12k1gsx).ant-layout .ant-layout-footer {\n  background: #444444 !important;\n}\n\n/* Further Specific Overrides */\n:where(.css-12k1gsx).ant-layout .ant-select-selector {\n  background: #272822 !important;\n}\n\n:where(.css-12k1gsx).ant-card,\n:where(.css-12k1gsx).ant-input-group {\n  background: #5b5b5b !important;\n}\n\n.account-label-width .ant-form-item-label {\n  text-align: left;\n  width: 100px;\n}\n\n.ant-layout-sider-children {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
